var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareAltSquareSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 5 5 L 5 27 L 27 27 L 27 5 L 5 5 z M 7 7 L 25 7 L 25 25 L 7 25 L 7 7 z M 20 10 A 2 2 0 0 0 18.007812 12.15625 L 13.320312 14.5 A 2 2 0 0 0 12 14 A 2 2 0 0 0 12 18 A 2 2 0 0 0 13.320312 17.5 L 18.007812 19.84375 A 2 2 0 0 0 20 22 A 2 2 0 0 0 20 18 A 2 2 0 0 0 18.679688 18.5 L 13.992188 16.15625 A 2 2 0 0 0 13.992188 15.84375 L 18.679688 13.5 A 2 2 0 0 0 20 14 A 2 2 0 0 0 20 10 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareAltSquareSolid);
export default __webpack_public_path__ + "static/media/share-alt-square-solid.b89f3f1395c97fa4550bb8b235b709a2.svg";
export { ForwardRef as ReactComponent };